import {isArray} from 'lodash';

const base64 = require('base-64');
const utf8 = require('utf8');

export {default as storage} from './storage';

export const calculateWindowSize = (windowWidth) => {
  if (windowWidth >= 1200) {
    return 'lg';
  }
  if (windowWidth >= 992) {
    return 'md';
  }
  if (windowWidth >= 768) {
    return 'sm';
  }
  return 'xs';
};

export const getApiUrl = () => {
  return `${
    process.env.REACT_APP_API_URL ||
    'https://ccedpapi-hnaqdzhnf7hyg9gn.z01.azurefd.net'
  }/v9`;
};

export const encodePassword = (pwd) => {
  const encoded = base64.encode(utf8.encode(pwd));
  return `hEx${encoded}`;
};

export const genSortField = (sortedFields) => {
  return sortedFields.length
    ? `${sortedFields[0].id}${sortedFields[0].desc ? '-desc' : '-asc'}`
    : undefined;
};

export const multiFilterJoin = (filters, multiOp) => {
  const filterStr = filters.join(`)${multiOp}(`);
  return `${filters.length > 1 ? '(' : ''}${filterStr}${
    filters.length > 1 ? ')' : ''
  }`;
};

export const genFilterQuery = (filters, multiOp = '~and~') => {
  // multi select filter query
  //   ProgramAreaTitle~eq~'Energy Information Management'~or~ProgramAreaTitle~eq~'Energy and Macroeconomics'
  // With multiple filters selected
  // (ProgramAreaTitle~eq~'Energy Information Management'~or~ProgramAreaTitle~eq~'Energy and Macroeconomics')~and~Serial~contains~'02'
  // Single search value
  // Serial~contains~'02'

  const localFilters = [];
  filters.forEach((item) => {
    if (isArray(item.value)) {
      const multiValue = item.value.map(
        (mValue) => `${item.id}~eq~'${mValue}'`
      );
      localFilters.push(multiValue.join('~or~'));
    } else {
      localFilters.push(`${item.id}${item.value.op}'${item.value.text}'`);
    }
  });
  return multiFilterJoin(localFilters, multiOp);
};

export const transformCorpStructure = (data) => {
  const corporates = data.corporates || [];
  const facilities = data.facilities || [];
  const subsidiaries = data.subsidiaries || [];
  const subFacilities = data.subFacilities || [];

  return corporates.map((item) => {
    const filteredFac = facilities
      .filter((fac) => fac.parentEntity === item.id)
      .map((fac) => {
        return {
          name: fac.name,
          path: `/facilities/${fac.id}`,
          icon: null,
          className: 'facility ml-1',
        };
      });
    const filteredSub = subsidiaries
      .filter((sub) => sub.parentEntity === item.id)
      .map((sub) => {
        const filteredSubFac = subFacilities
          .filter((fac) => fac.parentEntity === sub.id)
          .map((fac) => {
            return {
              name: fac.name,
              path: `/facilities/${fac.id}`,
              icon: null,
              className: 'facility ml-3',
            };
          });

        return {
          name: sub.name,
          path: `/subsidiaries/${sub.id}`,
          icon: null,
          className: 'subsidiary ml-1',
          children: [...filteredSubFac],
          expandAndLink: filteredSubFac.length > 0,
        };
      });

    return {
      name: item.name,
      id: item.id,
      className: 'corporate',
      path: '/',
      icon: null,
      children: [...filteredFac, ...filteredSub],
    };
  });
};

export const transformParentEntities = (data) => {
  const corporates = data.corporates || [];
  const subsidiaries = data.subsidiaries || [];

  return [
    ...corporates.map((item) => ({
      value: item.id,
      label: item.name,
      type: 'corporate',
      parentEntity: 0,
    })),
    ...subsidiaries.map((item) => ({
      value: item.id,
      label: item.name,
      type: 'subsidiary',
      parentEntity: item.parentEntity,
    })),
  ];
};
